import myzod, { Infer } from 'myzod'

export enum PaymentStatus {
  Successful = 'SUCCESSFUL',
  Failed = 'FAILED',
}

export const PaymentEventSchema = myzod.object({
  chargeId: myzod.string(),
  paymentStatus: myzod.enum(PaymentStatus),
  paymentProcessorResponse: myzod.string(),
})

export type PaymentEvent = Infer<typeof PaymentEventSchema>
